import { Directive, Inject, Input } from "@angular/core";
import { GenericActions } from "../../redux/generic-actions";
import { ImmutableRedux } from "../../redux/immutable-redux.service";
import { STATIC_FILTER_STATE_PROP } from "./state-props";

@Directive({
    selector: "[common-static-filter-action-creators]",
    exportAs: "CommonStaticFilterActionsDirective",
})
export class CommonStaticFilterActionsDirective {
    @Input("staticFilterStateProp") public stateProp: string;

    constructor(
        private ngRedux: ImmutableRedux<any>,
        @Inject(STATIC_FILTER_STATE_PROP) public rootProp,
    ) { }

    public reset() {
        this.ngRedux.dispatchFactory(GenericActions.STATE_RESET, this.rootProp, this.stateProp);
    }
}
